import { TableProps } from '@shared/Table'
import { t } from 'i18next'
import { Tooltip, Typography } from 'antd'

export const columns: () => TableProps<
  Omit<any, 'key'>
>['editColumns'] = () => ({
  id: {
    title: '№',
    width: 40,
    fixed: 'left',
    render: (value, record, index) => {
      return index + 1
    },
  },
  fullName: {
    title: t('orders.salaryCardOrder.tableTitles.fullName'),
    width: 250,
    ellipsis: true,
    hasSearch: true,
    fixed: 'left',
    renderText(value, record, index) {
      return (
        <Tooltip title={value}>
          <Typography.Text ellipsis>{value}</Typography.Text>
        </Tooltip>
      )
    },
  },
  serialType: {
    title: t('orders.salaryCardOrder.tableTitles.identityCardSeries'),
    width: 100,
    ellipsis: true,
    filterSelectOptions: [
      {
        value: '',
        label: 'Seçin',
      },
      {
        value: 'AZE',
        label: 'AZE',
      },
      {
        value: 'AA',
        label: 'AA',
      },
      {
        value: 'AB',
        label: 'AB',
      },
    ],
  },
  serialNo: {
    title: t('orders.salaryCardOrder.tableTitles.identityCardNumber'),
    ellipsis: true,
    hasSearch: true,
  },
  pin: {
    title: t('orders.salaryCardOrder.tableTitles.pin'),
    hasSearch: true,
  },
  position: {
    title: t('orders.salaryCardOrder.tableTitles.position'),
    hasSearch: true,
  },
  salary: {
    title: t('orders.salaryCardOrder.tableTitles.monthlySalary'),
    ellipsis: true,
    render(value, record, index) {
      return (
        <span style={{ display: 'flex', justifyContent: 'end' }}>{value}</span>
      )
    },
  },
  phone: {
    title: t('orders.salaryCardOrder.tableTitles.phoneNumber'),
    hasSearch: true,
  },
  // secretKey: {
  //   title: t('orders.salaryCardOrder.tableTitles.codeWord'),
  //   hasSorter: true,
  // },
  email: {
    title: t('orders.salaryCardOrder.tableTitles.email'),
  },
  status: {
    title: t('orders.salaryCardOrder.tableTitles.status'),
    hasSorter: true,
    filterSelectOptions: [
      {
        value: '',
        label: 'Bütün',
      },
      {
        value: 'Active',
        label: 'Active',
      },
      {
        value: 'Inactive',
        label: 'Inactive',
      },
    ],
    render(value, record) {
      const colors = { CLOSED: 'green', BANK_REJECTED: 'red', RIS_REJECTED: 'red' };
      const v: keyof typeof colors = record.risStatus === "RIS_REJECTED" ? record.risStatus : value
      
      return value || record.risStatus === "RIS_REJECTED" ? (
        <span
          {...(colors[v] ? { style: { color: colors[v] } } : {} )}
        >
          {t(`orders.salaryCardOrder.buttonsLabels.RadioButtonGroup.${v}`)}
        </span>
      ) : (
        <></>
      )
    },
  },
  description: {
    title: t('orders.salaryCardOrder.tableTitles.rejectedReason'),
    render(value, record, index) {
      const desc = record.risStatus === "RIS_REJECTED" ? record.risDescription : value;

      return <Tooltip title={desc}>{desc}</Tooltip>
    },
  },
})
